import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { JellyfinMediaSource } from "@/backend/jellyfin/api";

export interface JellyfinStore {
  url: string | null;
  token: string | null;
  userId: string | null;
  username: string | null;
  currentVideoId: string | null;
  mediaSources: JellyfinMediaSource[];
  currentMediaSourceId: string | null;
  currentAudioStreamIndex: number | null;
  setUrl(url: string | null): void;
  setCredentials(token: string, userId: string, username: string): void;
  clearCredentials(): void;
  setCurrentVideo(videoId: string, mediaSources: JellyfinMediaSource[]): void;
  setCurrentMediaSource(
    sourceId: string | null,
    audioStreamIndex: number | null,
  ): void;
}

export const useJellyfinStore = create(
  persist(
    immer<JellyfinStore>((set) => ({
      url: null,
      token: null,
      userId: null,
      username: null,
      currentVideoId: null,
      mediaSources: [],
      currentMediaSourceId: null,
      currentAudioStreamIndex: null,
      setUrl(url) {
        set((s) => {
          s.url = url;
        });
      },
      setCredentials(token, userId, username) {
        set((s) => {
          s.token = token;
          s.userId = userId;
          s.username = username;
        });
      },
      clearCredentials() {
        set((s) => {
          s.token = null;
          s.userId = null;
          s.username = null;
        });
      },
      setCurrentVideo(videoId, mediaSources) {
        set((s) => {
          s.currentVideoId = videoId;
          s.mediaSources = mediaSources;
          s.currentMediaSourceId = null;
          s.currentAudioStreamIndex = null;
        });
      },
      setCurrentMediaSource(sourceId, audioStreamIndex) {
        set((s) => {
          s.currentMediaSourceId = sourceId;
          s.currentAudioStreamIndex = audioStreamIndex;
        });
      },
    })),
    { name: "__MW::jellyfin" },
  ),
);
